// :cow: Cosmose CONFIDENTIAL :iso:
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, STATE_NAME } from '@med/app/home/demo/guided-tour/store/guided-tour.reducers';

export const selectGuidedTourFeature = createFeatureSelector<State>(STATE_NAME);

export const selectStep = createSelector(
  selectGuidedTourFeature,
  (state: State) => state.step,
);
